/* global Vue */

/******************************************
          подгружаем библиотеки
******************************************/

import components  from 'lib/components'
import router      from 'router'
import routeConfig from 'lib/route-config'
import menuRight   from 'components/menu-right'
import menuAccount from 'components/menu-account'
import style       from 'components/style.scss'

/******************************************
              конфигурируем
******************************************/

// configure router
routeConfig(router)
Vue.config.devtools = false
Vue.config.debug = false
const app = Vue.extend({
  replace: false,
  components: {
    menu: menuRight,
  }
})

/******************************************
                  старт
******************************************/

// запускаем роутер, когда на странице есть элемент app
if ( document.getElementById('app') )
  router.start(app, '#app')

//TODO: запускаем, когда авторизованы
const account = new Vue(menuAccount)



/** WEBPACK FOOTER **
 ** ./src/js/account.js
 **/